import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from '@app/app.module';
import { environment } from '@environments/environment';
import { BrowserTracing } from '@sentry/tracing';
import * as Sentry from '@sentry/angular';
import { version } from '@environments/version';

if (environment.production) {
  enableProdMode();
  if (window) {
    // window.console.log = function () { };
  }
}

if (environment.IsBet3000) {
  Sentry.init({
    release: environment.product + '@' + version,
    dsn: 'https://93670f227c414b499249f159a7c535ec@o1342496.ingest.sentry.io/6618219',
    integrations: [
      new BrowserTracing({
        tracingOrigins: ['localhost', 'https://m.bet3000.net', 'https://bet3000.de'],
        routingInstrumentation: Sentry.routingInstrumentation,
      }),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.1,
  });
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
